'use strict';

$(document).ready(function () {
    if ($('.optin-input').length !== 0 && !$('.optin-input').is(":checked")) {
        $(".button-optin-submit").prop('disabled', true);
    }

    $('.optin-input').change(function() {
        if ($(this).is(":checked")) {
            $(".button-optin-submit").prop('disabled', false);
        } else {
            $(".button-optin-submit").prop('disabled', true);
        }
    });
});